import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseURL, VERSION } from 'src/app/constant/constant';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  resendPassword(email:any): Observable<any> {
    return this.http.post(`${baseURL}users/${VERSION}/resendPassword?email=${email}`,email);
  }

  changePassword(data:any): Observable<any> {
    return this.http.put(`${baseURL}users/${VERSION}/changePassword`,data);
  }
}
